import strings from 'strings'


const STATUS_THRESHOLDS = [
  { min: 7, label: 'HEALTHY' },
  { min: 4, label: 'WATCH' },
  { min: 0, label: 'AT RISK' }
]

export const getHealthStatusLabel = (healthScore) => {
  const score = Number(healthScore) || 0
  return (STATUS_THRESHOLDS.find((tier) => score >= tier.min) || STATUS_THRESHOLDS[STATUS_THRESHOLDS.length - 1]).label
}

const HEADLINE_BY_STATUS = {
  HEALTHY: 'Healthy cash position',
  WATCH: 'Mixed signals this period',
  'AT RISK': 'Deteriorating position'
}

export const formatPeriodLabel = (dateStr) => {
  if (!dateStr) return ''
  const date = new Date(dateStr)
  if (Number.isNaN(date.getTime())) return dateStr
  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long' })
}

const formatMonthDay = (dateStr) => {
  if (!dateStr) return ''
  const date = new Date(dateStr)
  if (Number.isNaN(date.getTime())) return dateStr
  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })
}

export const deriveStatementVerdict = (report, previousReport) => {
  const insights = report.bankNotesInsightsData || {}
  const healthScore = insights.healthScore || 0
  const statusLabel = getHealthStatusLabel(healthScore)
  const periodLabel = formatPeriodLabel(report.date)
  const netCashFlow = (report.credits || 0) - (report.debits || 0)

  const carriedOver = previousReport && Math.abs((previousReport.endBalance || 0) - (report.startingBalance || 0)) < 0.01
  const startingBalanceNote = carriedOver
    ? `Carried from ${formatPeriodLabel(previousReport.date)}`
    : formatMonthDay(report.date)

  const creditsNote = report.credits === 0 ? 'Zero deposits recorded' : ''
  const debitsNote = report.debits === 0 ? 'Zero debit activity' : ''

  let runway = null
  if (netCashFlow < 0 && report.debits > 0 && report.endBalance > 0) {
    const periodsLeft = report.endBalance / report.debits
    runway = `At ${formatCurrencyPlain(report.debits)} of outflow per period and no replenishment, the remaining ${formatCurrencyPlain(report.endBalance)} covers ${periodsLeft.toFixed(1)} more periods.`
  }

  return {
    eyebrow: `${periodLabel.toUpperCase()} · ${strings.BANK_STATEMENT_VERDICT_LABEL}`,
    statusLabel,
    headline: HEADLINE_BY_STATUS[statusLabel],
    description: (insights.takeaways && insights.takeaways[0]) || '',
    runway,
    statCardNotes: {
      startingBalance: startingBalanceNote,
      credits: creditsNote,
      debits: debitsNote
    }
  }
}

const formatCurrencyPlain = (amount) => new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
}).format(Number(amount) || 0)

export const deriveComparisonVerdict = (report, fromScore, toScore) => {
  const trend = toScore > fromScore ? 'Improving' : toScore < fromScore ? 'Deteriorating' : 'Stable'
  const description = (report.overallHealthAnalysis && report.overallHealthAnalysis[0])
    || (report.accountStateAnalysis && report.accountStateAnalysis[0])
    || ''
  return { headline: trend, description }
}
